import React from "react";

const PHONE = "393793673831";
const MESSAGE = "Ciao! Ho visto Mini Style e vorrei informazioni su un prodotto.";

export default function WhatsAppButton() {
    const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contattaci su WhatsApp"
            title="Contattaci su WhatsApp"
            data-testid="whatsapp-fab"
            className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-30 flex items-center justify-center w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            style={{ backgroundColor: "#25D366" }}
        >
            <svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true">
                <path
                    fill="#FFFFFF"
                    d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977.906 2.834 1.09 2.152 2.72 3.79 4.929 4.85.622.302 2.058.997 2.75.997.4 0 .786-.126 1.174-.24.472-.14.99-.243 1.317-.6.15-.166.223-.377.256-.6.03-.257.03-.514.03-.771 0-.315-.286-.514-.6-.6zm-3.109-11.32C10.492 5.885 6 10.377 6 15.887c0 1.803.5 3.55 1.418 5.08L6 26l5.117-1.397a9.86 9.86 0 0 0 4.884 1.278c5.51 0 10.002-4.493 10.002-10.003C26.003 10.36 21.512 5.884 16 5.884zm0 18.28a8.24 8.24 0 0 1-4.207-1.148l-.302-.185-3.13.826.837-3.07-.2-.315a8.235 8.235 0 0 1-1.276-4.421c0-4.556 3.7-8.256 8.257-8.256 4.552 0 8.253 3.7 8.253 8.256 0 4.557-3.7 8.258-8.253 8.258z"
                />
            </svg>
        </a>
    );
}
